import { getCropUrl, parseFloatingDate } from '../../../Helpers/utils';
import { ImageModel } from '../../../models/ImageModel';
import { TileModel } from '../../models/TileModel';
import { format } from 'date-fns';

export default function BlogPostTile({ node }: TileModel) {
  const name = node.name.length > 50 ? `${node.name.substring(0, 49)}...` : node.name;
  const image = node.properties['image'] as ImageModel ?? null;
  const summary = node.properties['summary'].toString();
  const concatenatedSummary = summary.length > 80 ? `${summary.substring(0, 79)}...` : summary;
  // Floating wall-clock value: formatting it in a fixed zone rolled the date back
  // a day for visitors east of UTC.
  const postDate = parseFloatingDate(node.properties["postDate"]);
  const preTitle = [node.properties['author'], postDate ? format(postDate, 'MMM dd, yyyy') : '']
    .filter(x => x.length > 0)
    .join(' - ');

  return (
    <div className="cell blog-post-wrapper">
      <div className="thumbnail">
          <a href={node.url}>
              <img src={getCropUrl(image, 'tile')} alt={node.name} />
              <div className="caption">
                  <h6>{name}</h6>
                  <p>{concatenatedSummary}</p>
                  <span>{preTitle}</span><span className="go"><i className="fa fa-angle-right"></i></span>
              </div>
          </a>
        </div>
    </div>
  )
}